import { Pivot, PivotItem, Stack } from '@fluentui/react';
import '@xyflow/react/dist/style.css';
import React from 'react';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';
import { FlowApproval_Query } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/FlowApproval';
import { useStyles } from '../../index.styles';
import { Conditions } from '../Conditions';
import { ShimmerView } from '../shimmer';
import { BasicForm } from './BasicForm';

interface GeneralInfoProps {
  approvalTypes: ApprovalSetupFlowCommonData | undefined;
  approvalDetailsLoading: boolean;
  approvalDetailsData: FlowApproval_Query | undefined;
  selectedKey: string;
  setSelectedKey: React.Dispatch<React.SetStateAction<string>>;
}

export const GeneralInfo: React.FC<GeneralInfoProps> = ({
  approvalTypes,
  approvalDetailsLoading,
  approvalDetailsData,
  selectedKey,
  setSelectedKey,
}) => {
  const styles = useStyles();

  const getSelectedSection = (key: string) => {
    switch (key) {
      case 'BASIC':
        return (
          <BasicForm
            isNew={approvalDetailsData === undefined}
            approvalDetails={approvalDetailsData}
            data={approvalTypes}
          />
        );
      case 'CONDITIONS':
        return (
          <Conditions
            approvalDetailsLoading={approvalDetailsLoading}
            approvalTypes={approvalTypes}
            isDisabled={
              !(
                (approvalDetailsData?.approval?._isDeletable ?? true) &&
                (approvalDetailsData?.approval?._isUpdatable ?? true)
              )
            }
            isFlowUpdatable={
              approvalDetailsData?.approval?._isUpdatable ?? true
            }
          />
        );
    }
  };

  return (
    <Stack className={styles.bodyContainer}>
      <Stack horizontal tokens={{ padding: '0px 30px' }}>
        <Pivot
          selectedKey={selectedKey}
          onLinkClick={(item: PivotItem | undefined) => {
            setSelectedKey(item?.props.itemKey || 'BASIC');
          }}
          aria-label="Menu_Actions"
        >
          <PivotItem itemKey={'BASIC'} itemIcon="Attach" headerText="Basic" />
          <PivotItem
            itemKey={'CONDITIONS'}
            itemIcon="Attach"
            headerText="Conditions"
            // onRenderItemLink={PivotCustomRender}
          />
        </Pivot>
      </Stack>
      {approvalDetailsLoading ? (
        <ShimmerView />
      ) : (
        <Stack>
          <Stack>{getSelectedSection(selectedKey)}</Stack>
        </Stack>
      )}
    </Stack>
  );
};
